import { gql, TypedDocumentNode } from '@apollo/client'
import { employeesSidebarEmployeeFragment } from './employeesSidebarEmployeeFragment'
import type {
  SuEmployeesWithMissingCertificatesSidebarQuery,
  SuEmployeesWithMissingCertificatesSidebarQueryVariables
} from './__generated__/SuEmployeesWithMissingCertificatesSidebarQuery'

export const suEmployeesWithMissingCertificatesSidebarQuery: TypedDocumentNode<
  SuEmployeesWithMissingCertificatesSidebarQuery,
  SuEmployeesWithMissingCertificatesSidebarQueryVariables
> = gql`
  ${employeesSidebarEmployeeFragment}

  query SuEmployeesWithMissingCertificatesSidebarQuery(
    $periodStart: Date!
    $periodEnd: Date!
  ) {
    suEmployeesWithMissingCertificates(
      periodStart: $periodStart
      periodEnd: $periodEnd
    ) {
      ...EmployeesSidebarEmployeeFragment
    }
  }
`
